document.addEventListener(
  "DOMContentLoaded",
  function () {
    /* Fix to open megamenu on hover */
    let items = document
      .querySelector(".header")
      .querySelectorAll(".mega-menu");
    //console.log(items);
    let openedItem = null;
    items.forEach((item) => {
      item.addEventListener("mouseover", () => {
        if (openedItem && openedItem !== item) {
          openedItem.open = false;
        }
        openedItem = item;
        item.open = true;
        item.querySelector("ul").addEventListener("mouseleave", () => {
          setTimeout(() => {
            if (!item.matches(":hover")) {
              item.open = false;
              openedItem = null;
            }
          }, 200);
        });
        item.addEventListener("mouseleave", () => {
          setTimeout(() => {
            if (!item.matches(":hover")) {
              item.open = false;
              openedItem = null;
            }
          }, 200);
        });
      });
    });
  },
  false
);

// Hacky function to overrule Smile's obtrusive z-index
function reduceSmileZindex() {
  if (document.getElementById("smile-ui-lite-container")) {
    document.getElementById("smile-ui-lite-container").style.zIndex = "2";
  }
  if (document.getElementById("smile-ui-container")) {
    document.getElementById("smile-ui-container").style.zIndex = "2";
  }
}

/* Lower Smile launcher z-index when opening mobile menu */
document
  .getElementById("Details-menu-drawer-container")
  .addEventListener("click", function (event) {
    reduceSmileZindex();
  });

// Add to cart
var productFormSubmitBtn = document.getElementsByClassName(
  "product-form__submit"
);
for (var i = 0; i < productFormSubmitBtn.length; i++) {
  productFormSubmitBtn[i].addEventListener("click", function (event) {
    reduceSmileZindex();
  });
}

// Cart icon in top menu
document
  .getElementById("cart-icon-bubble")
  .addEventListener("click", function (event) {
    reduceSmileZindex();
  });
